import { render, staticRenderFns } from "./ForgotPasswordDoV2.vue?vue&type=template&id=d670faf2&scoped=true"
import script from "./ForgotPasswordDoV2.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDoV2.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordDoV2.vue?vue&type=style&index=0&id=d670faf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d670faf2",
  null
  
)

export default component.exports